import type { Action } from "../actions.types";
import { ACTION_TYPE_SLUG, TARGET_OBJECT_TYPE } from "../actions.constants";

/**
 * Organization-related action type slugs.
 * These actions are displayed in the Organization Admin section, not in phase sections.
 */
const ORG_ADMIN_ACTION_SLUGS = [
  ACTION_TYPE_SLUG.ORG_MANAGE,
  ACTION_TYPE_SLUG.ORG_DISPLAY_NAME,
  ACTION_TYPE_SLUG.ORG_ONBOARDING_QUIZ,
  ACTION_TYPE_SLUG.ORG_UPLOAD_LOGO,
  ACTION_TYPE_SLUG.ORG_UPDATE_SOCIALS,
];

/**
 * Check if an action is an organization admin action.
 * Org admin actions are displayed separately from program phase actions on the dashboard.
 *
 * An action is considered org admin if:
 * - It has an org-related action type slug, OR
 * - It's a send_invitation action targeted at an organization
 */
export function isOrgAdminAction(action: Action): boolean {
  const slug = action.action_type?.slug;

  // Check for org-related action types
  if (slug && (ORG_ADMIN_ACTION_SLUGS as readonly string[]).includes(slug)) {
    return true;
  }

  // send_invitation for organizations
  if (
    slug === ACTION_TYPE_SLUG.SEND_INVITATION &&
    action.target_object_type === TARGET_OBJECT_TYPE.ORGANIZATION
  ) {
    return true;
  }

  return false;
}
